import { OrgRole } from './org-role';
import { Organization } from './organization';
import { Right } from './right';

export class User {
  public id: number;
  public logon: string;
  public firstName: string;
  public lastName: string;
  public email: string;
  public admin: boolean;
  public active: boolean;
  public organizations: Organization[];
  public roles: OrgRole[];
  public rights: Right[];
}
